import {Component} from "@angular/core";
import {InventorySearchPageComponent} from "../../inventory-search-page/inventory-search-page.component";
import {InventoryEntityModel} from "../../inventory-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {InventoryEditPageComponent} from "../inventory-edit-page.component";
import {InventoryStockSizeData} from "../../inventory.data";
import {EditMode} from "../../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-inventory-edit-recipe",
    templateUrl: "./inventory-edit-recipe.component.html"
})
export class InventoryEditRecipeComponent {
    EditMode = EditMode;
    InventorySearchPageComponent = InventorySearchPageComponent;
    InventoryEditPageComponent = InventoryEditPageComponent;

    constructor(public model: InventoryEntityModel, public editService: EditService) {
    }

    populateRecipe(entity: InventoryStockSizeData): void {
        if (entity != null) {
            this.model.data.recipeStockSize.measureAmt = entity.measureAmt;
        }
    }
}
